import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import HeaderMenu from "../sidebar/headermenu";
import AccSettingHeader from "./acc_setting_header";
import { ResetPasswordApi } from "../../apis/user/reset_password_api";
var md5 = require('md5');

export default function PasswordReset() {
    const navigate = useNavigate();
    const [loginId, setLoginId] = useState("");
    const [loginType, setLoginType] = useState("");
    const [passLink, setPassLink] = useState(API_STATUS);
    const [userData, setUserData] = useState("");
    const [error, setError] = useState("");

    const SignupSchema = Yup.object().shape({
        cpassword: Yup.string()
            .min(6, 'Minimum 6 letters are required')
            .required('Enter current password'),
        password: Yup.string()
            .min(6, 'Minimum 6 letters are required')
            .required('Enter new password')
    });

    useEffect(() => {
        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            const userCode = sessionStorage.getItem('USER_CODE');
            setLoginId(userCode);

            const utype = sessionStorage.getItem('USER_TYPE');
            setLoginType(utype);
        }
    }, []);

    useEffect(() => {
        const loginData = sessionStorage.getItem('LOGIN_DATA');
        if (loginData !== null) {
            const uData = JSON.parse(loginData);
            setUserData(uData);
        }
    }, []);

    useEffect(() => {
        if (!passLink.isError && !passLink.isLoader && passLink.data != null) {
            const res = passLink.data;
            console.log(res);
            if (res['status'] == '1') {
                sessionStorage.removeItem('LOGIN_TOKEN');
                navigate('/login');
            }
            if (res['status'] == '0') {
                setError('Current password wrong');
            }


        }
    }, [passLink]);

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            {
                userData !== "" &&

                <div className="max-w-2xl mx-auto px-1 py-1">
                    <div class="page__heading py-6 mt-6">
                        <a href={'/profile/' + loginId}>
                            <ion-icon name="chevron-back-outline"></ion-icon> Back
                        </a>
                        <h1>Account Settings </h1>
                    </div>

                    <AccSettingHeader userData={userData} activeTab={'password_reset'} />

                    <div className="mt-6 mb-20 text-sm font-medium text-gray-600 dark:text-white/80">
                        <div className="uk-switcher bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                            <div className="uk-active" style={{ position: 'relative' }}>
                                <div>
                                    <div className="md:flex justify-center mb-5">
                                        <h3 class="text-md text-base font-semibold text-black dark:text-white"> Reset account password </h3>
                                    </div>
                                    <Formik
                                        enableReinitialize={true}
                                        initialValues={{
                                            password: "",
                                            cpassword: "",

                                        }}
                                        validationSchema={SignupSchema}
                                        onSubmit={values => {
                                            let body = values;
                                            body.password = md5(body.password);
                                            body.cpassword = md5(body.cpassword);

                                            ResetPasswordApi(body, setPassLink);
                                        }}
                                    >
                                        {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                                            <div className="space-y-6">
                                                {
                                                    error !== "" &&
                                                    <div className="alert text-red-600 text-md text-center">
                                                        {error}
                                                    </div>
                                                }
                                                <div className="md:flex items-center gap-10">
                                                    <label className="md:w-32 text-right"> Current Password </label>
                                                    <div className="flex-1 max-md:mt-4">
                                                        <Field type="password" name="cpassword" className="lg:w-1 w-full" />
                                                    </div>
                                                </div>
                                                {
                                                    errors.cpassword && touched.cpassword &&
                                                    <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.cpassword}</div>
                                                }

                                                <div className="md:flex items-center gap-10">
                                                    <label className="md:w-32 text-right"> New Password </label>
                                                    <div className="flex-1 max-md:mt-4">
                                                        <Field type="password" name="password" className="lg:w-1 w-full" />
                                                    </div>
                                                </div>

                                                {
                                                    errors.password && touched.password &&
                                                    <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.password}</div>
                                                }

                                                <div className="flex items-center justify-center gap-4 mt-16">
                                                    <button
                                                        onClick={() => {
                                                            if (!isValid) {
                                                                setFieldTouched('password');
                                                                setFieldTouched('cpassword');
                                                            } else {
                                                                setError("");
                                                                handleSubmit();
                                                            }
                                                        }}
                                                        type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Submit <span className="ripple-overlay"></span></button>
                                                </div>
                                            </div>
                                        )}
                                    </Formik>
                                    {
                                        passLink.isLoader &&
                                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                                            <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                            <span class="sr-only">...</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </main>
    </div>
}